import React from "react";

export default function Languages() {
  return (
    <React.Fragment>
      <div className="mt-3 p-3 section">
        <h1 className="section__h1 mb-4">Languages</h1>
        <p className="mb-1">
          <h6 className="d-inline">Українська:</h6> Вільно
        </p>
        <p className="mb-1">
          <h6 className="d-inline">Русский:</h6> Свободно
        </p>
        <p className="mb-1">
          <h6 className="d-inline">English:</h6> Intermediate
        </p>
      </div>
    </React.Fragment>
  );
}
